// src/stores/session.js
import { defineStore } from 'pinia'

function decodeJwt(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(atob(base64))
  } catch {
    return null
  }
}

export const useSessionStore = defineStore('session', {
  state: () => ({
    token: null,
    id: null,
    businessId: null,
    hasAccount: false,
    role: null,
    businessLogo: '',
    payload: null,
  }),

  getters: {
    isAuthed: (s) => !!s.token && !!s.payload && (Date.now() / 1000) < (s.payload.exp || 0),
    hasLogo:  (s) => !!s.businessLogo
  },

  actions: {
    setSession({ token, id, businessId, role, hasAccount }) {
      this.token = token || null
      this.payload = token ? decodeJwt(token) : null
      this.id = id || null
      this.businessId = businessId || null
      this.role = role || null
      this.hasAccount = !!hasAccount

      if (this.token) localStorage.setItem('token', this.token); else localStorage.removeItem('token')
      if (this.id) localStorage.setItem('id', this.id); else localStorage.removeItem('id')
      if (this.businessId) localStorage.setItem('businessId', this.businessId); else localStorage.removeItem('businessId')
      if (this.role) localStorage.setItem('role', this.role); else localStorage.removeItem('role')
      localStorage.setItem('hasAccount', String(this.hasAccount))
    },

    setHasAccount(v) {
      this.hasAccount = !!v
      localStorage.setItem('hasAccount', String(this.hasAccount))
    },

    setBusinessLogo(logo) {
      this.businessLogo = logo || ''
      if (this.businessLogo) localStorage.setItem('businessLogo', this.businessLogo)
      else localStorage.removeItem('businessLogo')
    },

    loadFromStorage() {
      const token = localStorage.getItem('token')
      this.token = token || null
      this.payload = token ? decodeJwt(token) : null
      this.id = localStorage.getItem('id') || null
      this.businessId = localStorage.getItem('businessId') || null
      this.role = localStorage.getItem('role') || null
      this.hasAccount = localStorage.getItem('hasAccount') === 'true'
      this.businessLogo = localStorage.getItem('businessLogo') || ''
    },

    clear() {
      this.token = null
      this.payload = null
      this.id = null
      this.businessId = null
      this.role = null
      this.hasAccount = false
      this.businessLogo = ''

      localStorage.removeItem('token')
      localStorage.removeItem('id')
      localStorage.removeItem('businessId')
      localStorage.removeItem('role')
      localStorage.removeItem('hasAccount')
      localStorage.removeItem('businessLogo')
    }
  }
})
